var site = site || {};
site.Newsletter = (function () {
    
    const handleNewsletterFormInput = () => {
        
        const newsletterFormHandler = () => {
            const newsletterForm = document.querySelector('#hsForm_48b55a41-5f96-4555-acfd-1a0b575e60e4');
            
            if(newsletterForm) {
                const newsletterInputs = document.querySelectorAll('#hsForm_48b55a41-5f96-4555-acfd-1a0b575e60e4 .hs-email input')
                const newsletterLabels = document.querySelectorAll('#hsForm_48b55a41-5f96-4555-acfd-1a0b575e60e4 .hs-email label')
                
                newsletterInputs.forEach((input) => {
                    input.placeholder = 'Your Email...';
                })
                newsletterLabels.forEach((label) => {
                    label.classList.add('sr-only');
                })
                
                clearInterval(formHandlerInterval);
            } 
        }
        const formHandlerInterval = setInterval(newsletterFormHandler, 1000);
    }
    
    // Return
    return {
        handleNewsletterFormInput : handleNewsletterFormInput
    };
}());